import { Injectable } from '@angular/core';
import { DropdownService, IDropdownData, IListService } from '@captiveaire/advanceddropdown';
import { IGridPagedResult } from '../../src/typings/IGridPagedResult';
import { ILocationSummary, ILocationSummarySearchCriteria } from '../../src/typings/models';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class LocationSummaryService implements IListService {
    // tslint:disable object-literal-sort-keys
    public static $name = 'locationSummaryService';

    constructor(
        private dropdownService: DropdownService,
        private proxyService: ProxyService
    ) {
    }

    // Check whether the user has access to view the Is Certified Location filter.
    public getCanManageIsCertified(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getCanManageIsCertified'
        }).as<boolean>();
    }

    // Check whether the user has access to view the Is AirQualityExcellence Location filter.
    public getCanManageIsAirQualityExcellence(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getCanManageIsAirQualityExcellence'
        }).as<boolean>();
    }

    public getList(query: ILocationSummarySearchCriteria):
        angular.IPromise<IGridPagedResult<ILocationSummary>> {

        const sort = (query.ascending) ? 0 : 1;
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getLocationList',
            queryParams: {
                'searchCriteria.pagingCriteria.includeTotalCount': query.includeTotalCount,
                'searchCriteria.pagingCriteria.skip': (query.page - 1) * query.limit,
                'searchCriteria.pagingCriteria.sortDirection': 0,
                'searchCriteria.pagingCriteria.sortExpressions': ['Description'],
                'searchCriteria.pagingCriteria.take': query.limit,
                'searchCriteria.wildcard': query.wildcard,
                'searchCriteria.IsCertified': query.isCertified,
                'searchCriteria.IsAirQualityExcellence': query.isAirQualityExcellence,
                'searchCriteria.customerId': query.customerId
            }
        }
        ).as<IGridPagedResult<ILocationSummary>>();
    }

    /* Not implemented */
    public getEndpointName() {
        return 'location-update-context';
    }

    public getListItem(id: string): angular.IPromise<IGridPagedResult<ILocationSummary>> {
        // Id must be a number
        const requestId = typeof id !== 'number' ? Number(id) : id;
        return this.proxyService.request({
                endPoint: 'location',
                route: 'getLocationList',
                queryParams: {
                    'searchCriteria.id': requestId,
                    'searchCriteria.pagingCriteria.includeTotalCount': false,
                    'searchCriteria.pagingCriteria.skip': 0,
                    'searchCriteria.pagingCriteria.sortDirection': 0,
                    'searchCriteria.pagingCriteria.sortExpressions': ['Id'],
                    'searchCriteria.pagingCriteria.take': 1
                }
            }
        ).as<IGridPagedResult<ILocationSummary>>();
    }

    public prepareDropdown(locationId: any): IDropdownData {
        const dropdown = this.dropdownService.prepareDropdown(
            'Location',
            'description',
            this,
            locationId
        );

        dropdown.titleHandler = (item: ILocationSummary) => {
            return `${item.street1} ${item.street2} ${item.city} ${item.state} ${item.zip} ${item.country}`;
        };

        dropdown.getList().finally(() => {
            dropdown.visible = dropdown.totalCount > 0;
        });

        return dropdown;
    }
}
